import type { WhatsAppInboxMessage } from '@zrsystem/contracts';

import { FormattedChatText } from '@/features/conversation/components/formatted-chat-text.js';
import { formatWhatsAppInboxTimestamp } from '@/features/notification/lib/whatsapp-inbox-timestamp.js';

export interface WhatsAppInboxTextBubbleProps {
  readonly message: WhatsAppInboxMessage;
}

export function WhatsAppInboxTextBubble({ message }: WhatsAppInboxTextBubbleProps) {
  const text = message.body?.trim();
  if (text === undefined || text.length === 0) {
    return null;
  }

  return (
    <div className="whatsapp-inbox-bubble__text">
      <p>
        <FormattedChatText text={text} />
      </p>
      <time className="whatsapp-inbox-bubble__time" dateTime={String(message.timestamp)}>
        {formatWhatsAppInboxTimestamp(message.timestamp)}
      </time>
    </div>
  );
}
